import { useMemo } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { VStack } from '@cbhq/cds-web/layout';

import { EarningsPage } from ':cloud/pages/EarningsPage';
import { StakingAPILanding } from ':cloud/pages/Staking/StakingAPILanding';
import { StakingCommunity } from ':cloud/pages/Staking/StakingCommunity';
import { AppRoute } from ':cloud/utils/routes';
import { RoutedTopNavTabs } from ':cloud/widgets/sharedcomponents/RoutedTopNavTabs';

export function Staking() {
  const tabs = useMemo(
    () => [
      { id: 'overview', label: 'Overview', route: AppRoute.Products.Staking },
      {
        id: 'supported-networks',
        label: 'Supported Networks',
        route: AppRoute.Products.StakingCommunity,
      },
      {
        id: 'earnings',
        label: 'Earnings',
        route: AppRoute.Products.StakingEarnings,
      },
    ],
    [],
  );

  return (
    <VStack width="100%">
      <RoutedTopNavTabs tabs={tabs} preserveProjectId={false} />
      <Switch>
        <Route exact path={AppRoute.Products.Staking}>
          <StakingAPILanding />
        </Route>
        <Route exact path={AppRoute.Products.StakingCommunity}>
          <StakingCommunity />
        </Route>
        <Route exact path={AppRoute.Products.StakingEarnings}>
          <EarningsPage />
        </Route>
        <Redirect to={AppRoute.Products.Staking} />
      </Switch>
    </VStack>
  );
}
